type Context = 'enrich';

type Section = 'history' | 'record';

type Value = `${Context}-${Section}`;

export const Keys: Record<Section, Value> = {
  history: 'enrich-history',
  record: 'enrich-record',
};
